import {
  type Filters,
  ForecastManagementMetadataResp,
  ForecastManagementResp,
  OverrideUpsertRequest,
} from '@components/StoreMonitoring/ForecastManagement/api/schema'
import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'
import { dateFormat } from '@constants/dateFormat'
import moment, { type Moment } from 'moment'

export const useForecastManagement = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const useForecastManagementOverview = (startDate: Moment, endDate: Moment, filters: Filters) => {
    const noFilters = Object.values(filters)?.every((filter) => !filter?.length)
    const payload = {
      start_date: moment(startDate).format(dateFormat.DATE_ZERO_TIME),
      end_date: moment(endDate).format(dateFormat.DATE_ZERO_TIME),
      ...filters,
    }
    return useQuery({
      queryKey: ['forecastManagementOverview', payload],
      queryFn: () => api.post('forecast_management/overview', payload),
      enabled: !noFilters,
    })
  }

  const useBulkForecastOverride = useMutation({
    mutationKey: ['bulkForecastOverride'],

    mutationFn: (payload) => {
      return api.post('forecast_management/bulk_override', payload)
    },
  })

  const useForecastManagementMetadata = (startDate: Moment, endDate: Moment) => {
    return useQuery({
      queryKey: ['forecastManagementMetadata'],
      queryFn: () => api.post('forecast_management/metadata', { start_date: startDate, end_date: endDate }),
    })
  }

  return {
    useForecastManagementOverview,
    useBulkForecastOverride,
    useForecastManagementMetadata,
  }
}
